import { Dropdown, DropdownProps } from "antd";
import styles from "./VLDropdown.module.scss";
import classNames from "classnames";

export const VLDropdown = (props: DropdownProps) => (
  <Dropdown
    {...props}
    overlayClassName={classNames(styles.VLDropdown, props.overlayClassName)}
  />
);
